<!--
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-09-22 16:05:09
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-10-24 19:16:11
 * @FilePath: /b2c_public_components/src/zz-new-report/src/common-pop-header.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <z-popup
    v-model="showPopup"
    position="bottom"
    class="b2c-common-popup"
    :get-container="getContainer"
    @click-overlay="closePopup"
    @close="closePopup"
  >
    <div class="b2c-popup-wrapper">
      <div class="header">
        <span class="title">{{ headMsg.title }}</span>
        <span class="desc">{{ headMsg.text }}</span>
        <img
          class="colse"
          src="https://pic4.zhuanstatic.com/zhuanzh/daf5cd71-69c8-4118-98c4-bd3f33051c80.png"
          alt=""
          @click="closePopup"
        />
      </div>
      <slot></slot>
    </div>
  </z-popup>
</template>
<script>
  import { Popup } from '@zz-common/zz-ui'
  export default {
    components: {
      [Popup.name]: Popup,
    },
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      headMsg: {
        type: Object,
        default: () => {},
      },
      getContainer: {
        type: [String, Object],
        default: null,
      },
    },
    data() {
      return {
        showPopup: false,
      }
    },
    watch: {
      show(val) {
        this.showPopup = val
      },
    },
    methods: {
      closePopup() {
        this.showPopup = false
        this.$emit('close')
      },
    },
  }
</script>
<style lang="scss">
  .b2c-common-popup {
    height: 80vh;
    width: 100%;
    &.z-iphone-x {
      padding-bottom: 0 !important;
    }
  }
  .z-popup {
    .b2c-popup-wrapper {
      height: 100%;
      position: relative;
      .header {
        height: 230px;
        width: 100%;
        position: fixed;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        .title {
          font-size: 40px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #111111;
          line-height: 40px;
        }
        .desc {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 26px;
          margin-top: 24px;
        }
        .colse {
          position: absolute;
          top: 0;
          right: 0;
          margin-top: 12px;
          margin-right: 12px;
          height: 24px;
          width: 24px;
          border: 20px solid transparent;
          background-clip: padding-box;
        }
      }
      &::after {
        position: absolute;
        height: 230px;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
        z-index: -1;
        content: '';
        display: block;
        background: url('https://pic5.zhuanstatic.com/zhuanzh/80cda8db-6ffa-4675-b13e-03bd61326eb9.png')
          no-repeat top left;
        background-size: contain;
      }
    }
  }
</style>
